import { useEffect } from "react";
import { UpdateAccountHeaderErrorKeys } from "../../login/components/UpdateAccountSection";
import translate from "../functions/translate";

interface HeadingProps {
    setApiErrorHeading: (value: React.SetStateAction<string | undefined>) => void
    apiErrorHeaderKey: UpdateAccountHeaderErrorKeys | null
    apiErrorMessage?: string | null
}

export const useUpdateAccountSetHeading = (props: HeadingProps) => {
    const { setApiErrorHeading, apiErrorHeaderKey, apiErrorMessage } = props;
    useEffect(() => {
        const errorHeaderKeyToMessage: {
          [key in UpdateAccountHeaderErrorKeys]: string
        } = {
            completeItems: translate("complete_items_to_update_account"),
            cantProcess: translate("we_cant_process_request"),
            cantFind: translate("we_cant_find_you"),
            doesntMatch: translate("your_username_password_not_match"),
            locked: translate("your_account_now_locked_protect_information"),
        }
        setApiErrorHeading(apiErrorHeaderKey ? errorHeaderKeyToMessage[apiErrorHeaderKey] : '');
    }, [apiErrorHeaderKey, apiErrorMessage, setApiErrorHeading]);
}